import { loadAbort } from "utilities/load-abort-axios.utility.ts"
import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL

export const login = (credentials) => {
  const controller = loadAbort()
  const email = credentials.email
  const password = credentials.password

  return {
    call: axios.post(`${API_URL}/users/login`, {
      email,
      password,
      signal: controller.signal,
    }),
    controller,
  }
}
